<template>
  <div class="ruleta-admin-container">
    <!-- Pestañas de navegación -->
    <ul class="nav nav-tabs" style="border: none !important" role="tablist">
      <li class="nav-item" role="presentation">
        <button
          class="nav-link"
          :class="activeTab === 'prizes' ? 'active' : ''"
          @click="activeTab = 'prizes'"
          type="button"
        >
          <i class="fas fa-list"></i> Premios Ganados
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button
          class="nav-link"
          :class="activeTab === 'wheel' ? 'active' : ''"
          @click="activeTab = 'wheel'"
          type="button"
        >
          <i class="fas fa-cog"></i> Configurar Ruleta
        </button>
      </li>
    </ul>

    <!-- Tab: Premios Ganados -->
    <div
      v-show="activeTab === 'prizes'"
      class="card"
      style="border-radius: 0 1rem 1rem 1rem !important"
    >
      <div class="card-body" style="padding:">
        <h5 class="card-title mb-4">
          <i class="fas fa-trophy text-warning"></i> Administración de Premios
          Ganados
        </h5>

        <!-- Estadísticas -->
        <div class="row mb-4">
          <div class="col-12 col-sm-6 col-md-3 mb-3">
            <div class="stat-card">
              <div class="stat-icon pending">
                <i class="fas fa-clock"></i>
              </div>
              <div class="stat-content">
                <h6 class="stat-value">{{ stats.pending }}</h6>
                <p class="stat-label">Pendientes de canje</p>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-3 mb-3">
            <div class="stat-card">
              <div class="stat-icon requested">
                <i class="fas fa-hourglass-half"></i>
              </div>
              <div class="stat-content">
                <h6 class="stat-value">{{ stats.requested }}</h6>
                <p class="stat-label">Canje solicitado</p>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-3 mb-3">
            <div class="stat-card">
              <div class="stat-icon sent">
                <i class="fas fa-shipping-fast"></i>
              </div>
              <div class="stat-content">
                <h6 class="stat-value">{{ stats.sent }}</h6>
                <p class="stat-label">Enviados</p>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-3 mb-3">
            <div class="stat-card">
              <div class="stat-icon delivered">
                <i class="fas fa-check-circle"></i>
              </div>
              <div class="stat-content">
                <h6 class="stat-value">{{ stats.delivered }}</h6>
                <p class="stat-label">Entregados</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Filtros -->
        <div class="row mb-3">
          <div class="col-12 col-md-4 mb-2">
            <select
              v-model="filters.status"
              class="form-control"
              @change="loadPrizes"
            >
              <option value="">Todos los estados</option>
              <option value="pending_redeem">Pendiente de canje</option>
              <option value="redeem_requested">Canje solicitado</option>
              <option value="sent">Enviado</option>
              <option value="delivered">Entregado</option>
            </select>
          </div>
          <div class="col-12 col-md-4 mb-2">
            <input
              v-model="filters.search"
              type="text"
              class="form-control"
              placeholder="Buscar por nombre de premio o usuario..."
              @input="loadPrizes"
            />
          </div>
          <div class="col-12 col-md-4 mb-2">
            <button class="btn btn-primary w-100" @click="loadPrizes">
              <i class="fas fa-sync"></i> Actualizar
            </button>
          </div>
        </div>

        <!-- Tabla de premios -->
        <div class="table-responsive">
          <table class="table table-hover">
            <thead>
              <tr>
                <th>ID Premio</th>
                <th>Usuario</th>
                <th>Premio</th>
                <th>Estado</th>
                <th>Ganado</th>
                <th>Solicitado</th>
                <th>Enviado</th>
                <th>Entregado</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody v-if="loading">
              <tr>
                <td colspan="9" class="text-center">
                  <i class="fas fa-spinner fa-spin"></i> Cargando...
                </td>
              </tr>
            </tbody>
            <tbody v-else-if="prizes.length === 0">
              <tr>
                <td colspan="9" class="text-center text-muted">
                  No hay premios registrados
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr v-for="prize in prizes" :key="prize.prizeId">
                <td>
                  <small>{{ prize.prizeId }}</small>
                </td>
                <td>{{ prize.userName || "N/A" }}</td>
                <td>{{ prize.prizeName }}</td>
                <td>
                  <span
                    class="badge"
                    :class="getStatusBadgeClass(prize.status)"
                  >
                    {{ getStatusText(prize.status) }}
                  </span>
                </td>
                <td>
                  <small>{{ formatDate(prize.createdAt) }}</small>
                </td>
                <td>
                  <small>{{ formatDate(prize.redeemedAt) || "N/A" }}</small>
                </td>
                <td>
                  <small>{{ formatDate(prize.sentAt) || "N/A" }}</small>
                </td>
                <td>
                  <small>{{ formatDate(prize.deliveredAt) || "N/A" }}</small>
                </td>
                <td>
                  <div class="btn-group" role="group">
                    <button
                      v-if="prize.status === 'pending_redeem'"
                      class="btn btn-sm btn-primary"
                      @click="updateStatus(prize, 'redeem_requested')"
                      title="Marcar como solicitado"
                    >
                      <i class="fas fa-check"></i>
                    </button>
                    <button
                      v-if="prize.status === 'redeem_requested'"
                      class="btn btn-sm btn-info"
                      @click="updateStatus(prize, 'sent')"
                      title="Marcar como enviado"
                    >
                      <i class="fas fa-shipping-fast"></i>
                    </button>
                    <button
                      v-if="prize.status === 'sent'"
                      class="btn btn-sm btn-success"
                      @click="updateStatus(prize, 'delivered')"
                      title="Marcar como entregado"
                    >
                      <i class="fas fa-check-circle"></i>
                    </button>
                    <button
                      class="btn btn-sm btn-secondary"
                      @click="viewPrizeDetails(prize)"
                      title="Ver detalles"
                    >
                      <i class="fas fa-eye"></i>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Paginación -->
        <div class="row mt-3" v-if="totalPages > 1">
          <div class="col-12">
            <nav>
              <ul class="pagination justify-content-center">
                <li class="page-item" :class="{ disabled: currentPage === 1 }">
                  <a
                    class="page-link"
                    href="#"
                    @click.prevent="changePage(currentPage - 1)"
                  >
                    Anterior
                  </a>
                </li>
                <li
                  v-for="page in totalPages"
                  :key="page"
                  class="page-item"
                  :class="{ active: currentPage === page }"
                >
                  <a
                    class="page-link"
                    href="#"
                    @click.prevent="changePage(page)"
                  >
                    {{ page }}
                  </a>
                </li>
                <li
                  class="page-item"
                  :class="{ disabled: currentPage === totalPages }"
                >
                  <a
                    class="page-link"
                    href="#"
                    @click.prevent="changePage(currentPage + 1)"
                  >
                    Siguiente
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>

    <!-- Tab: Configurar Ruleta -->
    <div
      v-show="activeTab === 'wheel'"
      class="card"
      style="border-radius: 0 1rem 1rem 1rem !important"
    >
      <div class="card-body">
        <div class="d-flex justify-content-between align-items-center mb-4">
          <h5 class="card-title mb-0">
            <i class="fas fa-cog text-primary"></i> Configurar Premios de la
            Ruleta
          </h5>
          <button
            class="btn btn-success"
            @click="saveWheelConfiguration"
            :disabled="wheelItems.length <= 1 || loadingWheelItems"
          >
            <i class="fas fa-save"></i> Guardar Configuración
          </button>
        </div>

        <!-- Lista de premios de la ruleta -->
        <div class="table-responsive">
          <table class="table table-hover">
            <thead>
              <tr>
                <th style="width: 50px">#</th>
                <th>Nombre</th>
                <th>Orden</th>
                <th>Imagen</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody v-if="loadingWheelItems">
              <tr>
                <td colspan="5" class="text-center">
                  <i class="fas fa-spinner fa-spin"></i> Cargando...
                </td>
              </tr>
            </tbody>
            <tbody v-else-if="wheelItems.length === 0">
              <tr>
                <td colspan="5" class="text-center text-muted">
                  No hay premios en la ruleta. Agrega premios desde "Premios Disponibles".
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr v-for="(item, index) in wheelItems" :key="item.id">
                <td>
                  <strong>{{ index + 1 }}</strong>
                </td>
                <td>{{ item.name }}</td>
                <td>
                  <span class="badge bg-primary">{{ index + 1 }}</span>
                </td>
                <td>
                  <img
                    v-if="item.imageUrl"
                    :src="item.imageUrl"
                    :alt="item.name"
                    style="
                      width: 50px;
                      height: 50px;
                      object-fit: cover;
                      border-radius: 4px;
                    "
                  />
                  <span v-else class="text-muted">Sin imagen</span>
                </td>
                <td>
                  <div class="btn-group" role="group">
                    <button
                      class="btn btn-sm btn-info"
                      @click="moveItem(index, 'up')"
                      :disabled="index === 0"
                      title="Mover arriba"
                    >
                      <i class="fas fa-arrow-up"></i>
                    </button>
                    <button
                      class="btn btn-sm btn-info"
                      @click="moveItem(index, 'down')"
                      :disabled="index === wheelItems.length - 1"
                      title="Mover abajo"
                    >
                      <i class="fas fa-arrow-down"></i>
                    </button>
                    <button
                      class="btn btn-sm btn-danger"
                      @click="removeFromWheel(item.id)"
                      title="Sacar de la ruleta"
                    >
                      <i class="fas fa-times"></i> Sacar de la ruleta
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="mt-3 p-3 bg-light border rounded">
          <small class="text-muted">
            <i class="fas fa-info-circle"></i> <strong>Nota:</strong> Solo se pueden agregar máximo 6 premios a la ruleta. La ruleta se activará para todos los usuarios solo cuando estén agregados exactamente 6 premios. El botón "Guardar Configuración" solo actualiza el orden en donde estarán los premios en la ruleta. Para agregar más premios, ve a la sección "Premios Disponibles".
          </small>
        </div>

        <!-- Opción: Incluir "Sigue participando" -->
        <div class="mt-4 p-3 border rounded bg-white">
          <h6 class="mb-3">
            <i class="fas fa-sliders-h text-secondary"></i> Opciones de la ruleta
          </h6>
          <div class="d-flex flex-wrap align-items-center gap-3">
            <div class="form-check form-switch mb-0">
              <input
                v-model="wheelSettings.allowsFailedSpin"
                class="form-check-input"
                type="checkbox"
                id="allowsFailedSpin"
              />
              <label class="form-check-label" for="allowsFailedSpin">
                Permitir giro sin premio ("Sigue participando")
              </label>
            </div>
            <small class="text-muted">
              Si está activado: 12 espacios (6 premios + 6 "Sigue participando"). Si está desactivado: 12 espacios con solo premios (cada premio aparece 2 veces; siempre se gana algo).
            </small>
            <button
              type="button"
              class="btn btn-outline-primary btn-sm"
              :disabled="savingWheelSettings"
              @click="saveWheelSettings"
            >
              <i v-if="savingWheelSettings" class="fas fa-spinner fa-spin"></i>
              <i v-else class="fas fa-save"></i>
              {{ savingWheelSettings ? "Guardando…" : "Guardar opciones" }}
            </button>
          </div>
        </div>

        <!-- Sección: Premios Disponibles -->
        <div class="mt-5">
          <div class="d-flex justify-content-between align-items-center mb-4">
            <h5 class="card-title mb-0">
              <i class="fas fa-gift text-success"></i> Premios Disponibles
            </h5>
            <button
              class="btn btn-primary"
              @click="openAddPrizeModal"
            >
              <i class="fas fa-plus"></i> Agregar Premio
            </button>
          </div>

          <div v-if="loadingAllPrizes" class="text-center py-4">
            <i class="fas fa-spinner fa-spin"></i> Cargando premios...
          </div>

          <div v-else-if="allPrizes.length === 0" class="text-center py-4 text-muted">
            No hay premios disponibles. Agrega el primero.
          </div>

          <div v-else class="row">
            <div
              v-for="prize in allPrizes"
              :key="prize.id"
              class="col-12 col-sm-6 col-md-4 col-lg-3 mb-4"
            >
              <div class="card h-100">
                <div class="card-body text-center">
                  <div class="mb-3">
                    <img
                      v-if="prize.imageUrl"
                      :src="prize.imageUrl"
                      :alt="prize.name"
                      style="
                        width: 100%;
                        height: 150px;
                        object-fit: cover;
                        border-radius: 8px;
                      "
                    />
                    <div
                      v-else
                      class="d-flex align-items-center justify-content-center"
                      style="
                        width: 100%;
                        height: 150px;
                        background-color: #f8f9fa;
                        border-radius: 8px;
                      "
                    >
                      <i class="fas fa-image fa-3x text-muted"></i>
                    </div>
                  </div>
                  <h6 class="card-title">{{ prize.name }}</h6>
                  <div v-if="isPrizeInWheel(prize.id)" class="mt-2">
                    <span class="badge bg-success">
                      <i class="fas fa-check-circle"></i> Ya está agregado a la ruleta
                    </span>
                  </div>
                  <div v-else-if="wheelItems.length >= 6" class="mt-2">
                    <span class="badge bg-warning">
                      <i class="fas fa-exclamation-triangle"></i> Máximo 6 premios en la ruleta
                    </span>
                  </div>
                  <button
                    v-else
                    class="btn btn-primary btn-sm mt-2"
                    @click="addToWheel(prize.id)"
                    :disabled="loadingWheelItems"
                  >
                    <i class="fas fa-plus"></i> Agregar a la ruleta
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de detalles -->
    <VueFinalModal
      v-model="showPrizeDetailsModal"
      :esc-to-close="true"
      class="modal-container"
      content-class="modal-content"
    >
      <div class="modal__content">
        <div class="row">
          <div class="col-11 col-sm-11 col-md-11 col-xl-11 col-lg-11">
            <h5 class="modal-title">Detalles del Premio</h5>
          </div>
          <div
            class="col-1 col-sm-1 col-md-1 col-xl-1 col-lg-1"
            style="padding: 0; display: flex; justify-content: center"
            @click="closePrizeDetailsModal"
          >
            <i class="fas fa-times-square close_modal"></i>
          </div>
        </div>
        <div v-if="selectedPrize" class="mt-3">
          <div class="row">
            <div class="col-12 col-md-6 mb-3">
              <strong>ID Premio:</strong>
              <p>{{ selectedPrize.prizeId }}</p>
            </div>
            <div class="col-12 col-md-6 mb-3">
              <strong>Usuario:</strong>
              <p>{{ selectedPrize.userName || "N/A" }}</p>
            </div>
            <div class="col-12 col-md-6 mb-3">
              <strong>Premio:</strong>
              <p>{{ selectedPrize.prizeName }}</p>
            </div>
            <div class="col-12 col-md-6 mb-3">
              <strong>Estado:</strong>
              <p>
                <span
                  class="badge"
                  :class="getStatusBadgeClass(selectedPrize.status)"
                >
                  {{ getStatusText(selectedPrize.status) }}
                </span>
              </p>
            </div>
            <div class="col-12 mb-3" v-if="selectedPrize.redeemData">
              <strong>Datos de Canje:</strong>
              <div class="card mt-2">
                <div class="card-body">
                  <p>
                    <strong>Nombre:</strong>
                    {{ selectedPrize.redeemData.fullName }}
                  </p>
                  <p>
                    <strong>Cédula:</strong> {{ selectedPrize.redeemData.dni }}
                  </p>
                  <p>
                    <strong>Teléfono:</strong>
                    {{ selectedPrize.redeemData.phone }}
                  </p>
                  <p>
                    <strong>Email:</strong> {{ selectedPrize.redeemData.email }}
                  </p>
                  <p>
                    <strong>Dirección:</strong>
                    {{ selectedPrize.redeemData.address }}
                  </p>
                  <p>
                    <strong>Referencias:</strong>
                    {{ selectedPrize.redeemData.references }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </VueFinalModal>

    <!-- Modal para agregar/editar premio -->
    <VueFinalModal
      v-model="showPrizeItemModal"
      :esc-to-close="true"
      class="modal-container"
      content-class="modal-content"
    >
      <div class="modal__content">
        <div class="row">
          <div class="col-11 col-sm-11 col-md-11 col-xl-11 col-lg-11">
            <h5 class="modal-title">
              {{ editingPrizeItem ? "Editar Premio" : "Agregar Premio" }}
            </h5>
          </div>
          <div
            class="col-1 col-sm-1 col-md-1 col-xl-1 col-lg-1"
            style="padding: 0; display: flex; justify-content: center"
            @click="closePrizeItemModal"
          >
            <i class="fas fa-times-square close_modal"></i>
          </div>
        </div>
        <form @submit.prevent="savePrizeItem" class="mt-3">
          <div class="row">
            <div class="col-12 mb-3">
              <label class="form-control-label" style="font-weight: bold">
                Nombre del Premio
              </label>
              <input
                required
                placeholder="Ej: Botellon Bitlo - Negro"
                class="form-control"
                type="text"
                v-model="prizeItemForm.name"
              />
            </div>
            <div class="col-12 mb-3">
              <label class="form-control-label" style="font-weight: bold">
                Imagen del Premio
              </label>
              <!-- Zona de drag and drop -->
              <div
                class="dropzone"
                :class="{
                  'dropzone-active': isDragging,
                  'dropzone-has-image':
                    prizeItemForm.imagePreview ||
                    (editingPrizeItem && editingPrizeItem.imageUrl),
                }"
                @dragover.prevent="handleDragOver"
                @dragleave.prevent="handleDragLeave"
                @drop.prevent="handleDrop"
                @click="triggerFileInput"
              >
                <input
                  ref="imageInput"
                  type="file"
                  accept="image/*"
                  @change="handleImageSelect"
                  style="display: none"
                />
                <!-- Contenido cuando no hay imagen -->
                <div
                  v-if="
                    !prizeItemForm.imagePreview &&
                    !(editingPrizeItem && editingPrizeItem.imageUrl)
                  "
                  class="dropzone-content"
                >
                  <i class="fas fa-cloud-upload-alt dropzone-icon"></i>
                  <p class="dropzone-text">
                    Arrastra y suelta una imagen aquí o haz clic para
                    seleccionar
                  </p>
                  <small class="dropzone-hint"
                    >Formatos permitidos: JPG, PNG, GIF. Tamaño máximo:
                    5MB</small
                  >
                </div>
                <!-- Preview de nueva imagen -->
                <div v-if="prizeItemForm.imagePreview" class="dropzone-preview">
                  <img
                    :src="prizeItemForm.imagePreview"
                    alt="Preview"
                    class="dropzone-image"
                  />
                  <button
                    type="button"
                    class="btn btn-sm btn-danger dropzone-remove"
                    @click.stop="removeImage"
                  >
                    <i class="fas fa-times"></i>
                  </button>
                </div>
                <!-- Mostrar imagen actual si está editando -->
                <div
                  v-else-if="editingPrizeItem && editingPrizeItem.imageUrl"
                  class="dropzone-preview"
                >
                  <img
                    :src="editingPrizeItem.imageUrl"
                    alt="Imagen actual"
                    class="dropzone-image"
                  />
                  <button
                    type="button"
                    class="btn btn-sm btn-danger dropzone-remove"
                    @click.stop="removeImage"
                  >
                    <i class="fas fa-times"></i>
                  </button>
                  <p class="dropzone-current-label">Imagen actual</p>
                </div>
              </div>
              <!-- Indicador de carga -->
              <div v-if="uploadingImage" class="mt-2 text-center">
                <i class="fas fa-circle-notch fa-spin text-primary"></i>
                <span class="ms-2">Subiendo imagen...</span>
              </div>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-12">
              <button type="submit" class="btn btn-primary w-100">
                <i class="fas fa-save"></i>
                {{ editingPrizeItem ? "Actualizar" : "Agregar" }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </VueFinalModal>
  </div>
</template>

<script>
import { VueFinalModal } from "vue-final-modal";
import "vue-final-modal/style.css";
import "firebase/compat/storage";

export default {
  name: "RuletaAdmin",
  components: {
    VueFinalModal,
  },
  props: {
    tokenAuth: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      prizes: [],
      stats: {
        pending: 0,
        requested: 0,
        sent: 0,
        delivered: 0,
      },
      filters: {
        status: "",
        search: "",
      },
      currentPage: 1,
      itemsPerPage: 10,
      totalPages: 1,
      selectedPrize: null,
      showPrizeDetailsModal: false,
      activeTab: "prizes",
      // Configuración de la ruleta
      wheelItems: [],
      wheelSettings: {
        allowsFailedSpin: true,
      },
      loadingWheelItems: false,
      savingWheelSettings: false,
      showPrizeItemModal: false,
      editingPrizeItem: null,
      prizeItemForm: {
        name: "",
        imageFile: null,
        imageUrl: "",
        imagePreview: null,
      },
      uploadingImage: false,
      isDragging: false,
      // Todos los premios disponibles
      allPrizes: [],
      loadingAllPrizes: false,
    };
  },
  mounted() {
    this.loadPrizes();
    this.loadStats();
    this.loadWheelItems();
    this.loadAllPrizes();
  },
  methods: {
    async loadPrizes() {
      this.loading = true;
      try {
        this.loadStats();
        const response = await this.$https.get("/prize/admin/list", {
          params: {
            status: this.filters.status || "",
            search: this.filters.search || "",
            page: this.currentPage,
            limit: this.itemsPerPage,
          },
        });

        if (response.data.code === 200) {
          this.prizes = response.data.data || [];
          this.totalPages = response.data.pagination?.totalPages || 1;
        } else {
          throw new Error(response.data.error || "Error al cargar premios");
        }
      } catch (error) {
        console.error("Error al cargar premios:", error);
        this.$toast.error(
          error.response?.data?.error || "Error al cargar los premios",
          {
            position: "top-right",
            max: 10,
          }
        );
      } finally {
        this.loading = false;
      }
    },
    async loadStats() {
      try {
        const response = await this.$https.get("/prize/admin/stats");

        if (response.data.code === 200) {
          this.stats = {
            pending: response.data.data.pending || 0,
            requested: response.data.data.requested || 0,
            sent: response.data.data.sent || 0,
            delivered: response.data.data.delivered || 0,
          };
        }
      } catch (error) {
        console.error("Error al cargar estadísticas:", error);
        // No mostrar error al usuario, solo log
      }
    },
    async updateStatus(prize, newStatus) {
      try {
        const response = await this.$https.put(
          `/prize/${prize.prizeId}/status`,
          {
            status: newStatus,
          }
        );

        if (response.data.code === 200) {
          this.$swal({
            title: "¡Éxito!",
            text: "Estado del premio actualizado correctamente",
            icon: "success",
            confirmButtonText: "OK",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });

          this.loadPrizes();
          this.loadStats();
        } else {
          throw new Error(response.data.error || "Error al actualizar estado");
        }
      } catch (error) {
        console.error("Error al actualizar estado:", error);
        this.$toast.error(
          error.response?.data?.error ||
            "Error al actualizar el estado del premio",
          {
            position: "top-right",
            max: 10,
          }
        );
      }
    },
    async viewPrizeDetails(prize) {
      try {
        const response = await this.$https.get(`/prize/${prize.prizeId}`);
        if (response.data.code === 200) {
          this.selectedPrize = response.data.data;
          this.showPrizeDetailsModal = true;
        } else {
          throw new Error(response.data.error || "Error al cargar detalles");
        }
      } catch (error) {
        console.error("Error al cargar detalles:", error);
        this.$toast.error(
          error.response?.data?.error || "Error al cargar los detalles",
          {
            position: "top-right",
            max: 10,
          }
        );
      }
    },
    closePrizeDetailsModal() {
      this.showPrizeDetailsModal = false;
      this.selectedPrize = null;
    },
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
        this.loadPrizes();
      }
    },
    getStatusText(status) {
      const statusMap = {
        pending_redeem: "Pendiente de canje",
        redeem_requested: "Canje solicitado",
        sent: "Enviado",
        delivered: "Entregado",
      };
      return statusMap[status] || status;
    },
    getStatusBadgeClass(status) {
      const classMap = {
        pending_redeem: "bg-warning",
        redeem_requested: "bg-info",
        sent: "bg-primary",
        delivered: "bg-success",
      };
      return classMap[status] || "bg-secondary";
    },
    formatDate(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      return date.toLocaleDateString("es-ES", {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    },
    // Métodos para gestión de premios de la ruleta
    /**
     * Estructura del objeto Prize Item (Premio de la Ruleta) en la base de datos:
     *
     * {
     *   id: string,                    // ID único del premio
     *   name: string,                  // Nombre del premio (ej: "Botellon Bitlo - Negro")
     *   value: number,                 // Orden en la ruleta (1-6)
     *   imageUrl: string | null       // URL de la imagen en Firebase Storage (ej: "https://firebasestorage.googleapis.com/...")
     * }
     *
     * Nota: La imagen se sube a Firebase Storage en la ruta: "prizeImages/prize_{timestamp}_{filename}"
     * y la URL se obtiene automáticamente después de la subida.
     */
    async loadWheelItems() {
      this.loadingWheelItems = true;
      try {
        const response = await this.$https.get("/prize/wheel/items");

        if (response.data.code === 200) {
          const payload = response.data.data;
          const dataArray = Array.isArray(payload) ? payload : payload?.prizes || [];
          this.wheelItems = dataArray.filter(
            (item) => item.value != null
          );
          this.wheelItems.sort((a, b) => (a.value || 0) - (b.value || 0));
          this.updateItemValues();
          if (payload && typeof payload === "object" && !Array.isArray(payload) && payload.settings) {
            this.wheelSettings.allowsFailedSpin = payload.settings.allowsFailedSpin !== false;
          }
        } else {
          throw new Error(
            response.data.error || "Error al cargar premios de la ruleta"
          );
        }
      } catch (error) {
        console.error("Error al cargar items de la ruleta:", error);
        this.$toast.error(
          error.response?.data?.error ||
            "Error al cargar la configuración de la ruleta",
          {
            position: "top-right",
            max: 10,
          }
        );
      } finally {
        this.loadingWheelItems = false;
      }
    },
    async loadAllPrizes() {
      this.loadingAllPrizes = true;
      try {
        const response = await this.$https.get("/prize/wheel/all-items");

        if (response.data.code === 200) {
          this.allPrizes = response.data.data || [];
        } else {
          throw new Error(
            response.data.error || "Error al cargar todos los premios"
          );
        }
      } catch (error) {
        console.error("Error al cargar todos los premios:", error);
        this.$toast.error(
          error.response?.data?.error || "Error al cargar los premios",
          {
            position: "top-right",
            max: 10,
          }
        );
      } finally {
        this.loadingAllPrizes = false;
      }
    },
    isPrizeInWheel(prizeId) {
      return this.wheelItems.some((item) => item.id === prizeId);
    },
    async addToWheel(prizeId) {
      if (this.wheelItems.length >= 6) {
        this.$swal({
          title: "Límite alcanzado",
          text: "Solo se pueden agregar máximo 6 premios a la ruleta",
          icon: "warning",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
        return;
      }

      try {
        this.loadingWheelItems = true;
        const response = await this.$https.put(
          `/prize/wheel/items/${prizeId}/add-to-wheel`
        );

        if (response.data.code === 200) {
          this.$toast.success("Premio agregado a la ruleta correctamente", {
            position: "top-right",
            max: 10,
          });
          await this.loadWheelItems();
          await this.loadAllPrizes();
        } else {
          throw new Error(response.data.error || "Error al agregar premio");
        }
      } catch (error) {
        console.error("Error al agregar premio a la ruleta:", error);
        this.$toast.error(
          error.response?.data?.error ||
            "Error al agregar el premio a la ruleta",
          {
            position: "top-right",
            max: 10,
          }
        );
      } finally {
        this.loadingWheelItems = false;
      }
    },
    async removeFromWheel(prizeId) {
      const result = await this.$swal({
        title: "¿Estás seguro?",
        text: "El premio será removido de la ruleta pero no se eliminará",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, sacar de la ruleta",
        cancelButtonText: "Cancelar",
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: "btn btn-secondary",
        },
        buttonsStyling: false,
      });

      if (result.isConfirmed) {
        try {
          this.loadingWheelItems = true;
          const response = await this.$https.put(
            `/prize/wheel/items/${prizeId}/remove-from-wheel`
          );

          if (response.data.code === 200) {
            this.$toast.success("Premio removido de la ruleta correctamente", {
              position: "top-right",
              max: 10,
            });
            await this.loadWheelItems();
            await this.loadAllPrizes();
          } else {
            throw new Error(response.data.error || "Error al remover premio");
          }
        } catch (error) {
          console.error("Error al remover premio de la ruleta:", error);
          this.$toast.error(
            error.response?.data?.error ||
              "Error al remover el premio de la ruleta",
            {
              position: "top-right",
              max: 10,
            }
          );
        } finally {
          this.loadingWheelItems = false;
        }
      }
    },
    openAddPrizeModal() {
      this.editingPrizeItem = null;
      this.prizeItemForm = {
        name: "",
        imageFile: null,
        imageUrl: "",
        imagePreview: null,
      };
      // Limpiar input de archivo
      if (this.$refs.imageInput) {
        this.$refs.imageInput.value = "";
      }
      this.showPrizeItemModal = true;
    },
    closePrizeItemModal() {
      this.showPrizeItemModal = false;
      this.editingPrizeItem = null;
      this.prizeItemForm = {
        name: "",
        imageFile: null,
        imageUrl: "",
        imagePreview: null,
      };
      // Limpiar input de archivo
      if (this.$refs.imageInput) {
        this.$refs.imageInput.value = "";
      }
    },
    triggerFileInput() {
      if (this.$refs.imageInput) {
        this.$refs.imageInput.click();
      }
    },
    handleDragOver(event) {
      event.preventDefault();
      this.isDragging = true;
    },
    handleDragLeave(event) {
      event.preventDefault();
      this.isDragging = false;
    },
    handleDrop(event) {
      event.preventDefault();
      this.isDragging = false;

      const files = event.dataTransfer.files;
      if (files && files.length > 0) {
        this.processImageFile(files[0]);
      }
    },
    handleImageSelect(event) {
      const file = event.target.files[0];
      if (file) {
        this.processImageFile(file);
      }
    },
    processImageFile(file) {
      if (!file) return;

      // Validar tipo de archivo
      const validTypes = ["image/jpeg", "image/jpg", "image/png", "image/gif"];
      if (!validTypes.includes(file.type)) {
        this.$toast.error("El archivo debe ser una imagen (JPG, PNG o GIF)", {
          position: "top-right",
          max: 10,
        });
        if (this.$refs.imageInput) {
          this.$refs.imageInput.value = "";
        }
        return;
      }

      // Validar tamaño (5MB máximo)
      const fileSizeInMB = file.size / 1024 / 1024;
      if (fileSizeInMB > 5) {
        this.$toast.error("La imagen debe pesar menos de 5MB", {
          position: "top-right",
          max: 10,
        });
        if (this.$refs.imageInput) {
          this.$refs.imageInput.value = "";
        }
        return;
      }

      // Guardar archivo y crear preview
      this.prizeItemForm.imageFile = file;
      const reader = new FileReader();
      reader.onload = (e) => {
        this.prizeItemForm.imagePreview = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    removeImage() {
      this.prizeItemForm.imageFile = null;
      this.prizeItemForm.imagePreview = null;
      if (this.$refs.imageInput) {
        this.$refs.imageInput.value = "";
      }
    },
    // Convertir archivo a base64
    fileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          resolve(reader.result);
        };
        reader.onerror = (error) => {
          reject(error);
        };
        reader.readAsDataURL(file);
      });
    },
    async savePrizeItem() {
      try {
        this.uploadingImage = true;

        // Preparar datos para enviar
        const requestData = {
          name: this.prizeItemForm.name,
        };

        // Convertir imagen a base64 si hay un archivo nuevo
        if (this.prizeItemForm.imageFile) {
          const base64Image = await this.fileToBase64(
            this.prizeItemForm.imageFile
          );
          requestData.imageBase64 = base64Image;
        } else if (
          this.editingPrizeItem &&
          !this.prizeItemForm.imagePreview &&
          !this.editingPrizeItem.imageUrl
        ) {
          // Si se está editando y se removió la imagen
          requestData.imageBase64 = null;
        }

        let response;
        if (this.editingPrizeItem) {
          // Actualizar premio existente
          response = await this.$https.put(
            `/prize/wheel/items/${this.editingPrizeItem.id}`,
            requestData
          );
        } else {
          // Crear nuevo premio
          response = await this.$https.post(
            "/prize/wheel/items",
            requestData
          );
        }

        if (response.data.code === 200 || response.data.code === 201) {
          this.$toast.success(
            this.editingPrizeItem
              ? "Premio actualizado correctamente"
              : "Premio agregado correctamente",
            {
              position: "top-right",
              max: 10,
            }
          );

          // Recargar la lista de premios
          await this.loadWheelItems();
          await this.loadAllPrizes();
          await this.loadPrizes();
          this.closePrizeItemModal();
        } else {
          throw new Error(response.data.error || "Error al guardar premio");
        }
      } catch (error) {
        console.error("Error al guardar premio:", error);
        this.$toast.error(
          error.response?.data?.error || "Error al guardar el premio",
          {
            position: "top-right",
            max: 10,
          }
        );
      } finally {
        this.uploadingImage = false;
      }
    },
    moveItem(index, direction) {
      if (direction === "up" && index > 0) {
        const temp = this.wheelItems[index];
        this.wheelItems[index] = this.wheelItems[index - 1];
        this.wheelItems[index - 1] = temp;
        // Actualizar valores según nuevo orden
        this.updateItemValues();
      } else if (direction === "down" && index < this.wheelItems.length - 1) {
        const temp = this.wheelItems[index];
        this.wheelItems[index] = this.wheelItems[index + 1];
        this.wheelItems[index + 1] = temp;
        // Actualizar valores según nuevo orden
        this.updateItemValues();
      }
      // Nota: Los cambios se guardan cuando el usuario hace clic en "Guardar Configuración"
    },
    updateItemValues() {
      // Actualizar el valor de cada item según su posición en el array
      this.wheelItems.forEach((item, index) => {
        item.value = index + 1;
      });
    },
    async saveWheelConfiguration() {
      this.loadingWheelItems = true;
      try {
        const items = this.wheelItems.map((item, index) => ({
          id: item.id,
          value: index + 1,
        }));

        const response = await this.$https.put(
          "/prize/wheel/items/reorder",
          {
            items,
          }
        );

        if (response.data.code === 200) {
          this.$swal({
            title: "¡Éxito!",
            text: "Configuración de la ruleta guardada correctamente",
            icon: "success",
            confirmButtonText: "OK",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });

          // Recargar la lista para asegurar sincronización
          await this.loadWheelItems();
        } else {
          throw new Error(
            response.data.error || "Error al guardar configuración"
          );
        }
      } catch (error) {
        console.error("Error al guardar configuración:", error);
        this.$toast.error(
          error.response?.data?.error || "Error al guardar la configuración",
          {
            position: "top-right",
            max: 10,
          }
        );
      } finally {
        this.loadingWheelItems = false;
      }
    },
    async saveWheelSettings() {
      this.savingWheelSettings = true;
      try {
        const response = await this.$https.put("/prize/wheel/settings", {
          allowsFailedSpin: this.wheelSettings.allowsFailedSpin,
        });
        if (response.data.code === 200) {
          this.$toast.success("Opciones de la ruleta guardadas correctamente", {
            position: "top-right",
            max: 10,
          });
        } else {
          throw new Error(response.data.error || "Error al guardar opciones");
        }
      } catch (error) {
        console.error("Error al guardar opciones de la ruleta:", error);
        this.$toast.error(
          error.response?.data?.error || "Error al guardar las opciones",
          { position: "top-right", max: 10 }
        );
      } finally {
        this.savingWheelSettings = false;
      }
    },
  },
};
</script>

<style scoped>
.ruleta-admin-container {
  padding: 20px;
}

.stat-card {
  display: flex;
  align-items: center;
  padding: 15px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border-left: 4px solid #0075d2;
}

.stat-icon {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
  font-size: 24px;
  color: white;
}

.stat-icon.pending {
  background-color: #ffc107;
}

.stat-icon.requested {
  background-color: #17a2b8;
}

.stat-icon.sent {
  background-color: #007bff;
}

.stat-icon.delivered {
  background-color: #28a745;
}

.stat-content {
  flex: 1;
}

.stat-value {
  font-size: 24px;
  font-weight: 700;
  margin: 0;
  color: #333;
}

.stat-label {
  font-size: 12px;
  margin: 0;
  color: #666;
  text-transform: uppercase;
}

.table th {
  background-color: #f8f9fa;
  font-weight: 700;
  font-size: 12px;
  text-transform: uppercase;
}

.badge {
  padding: 6px 12px;
  font-size: 11px;
  font-weight: 700;
}

.btn-group .btn {
  margin-right: 5px;
}

.btn-group .btn:last-child {
  margin-right: 0;
}

.color-preview {
  width: 30px;
  height: 30px;
  border: 1px solid #ddd;
  border-radius: 4px;
  display: inline-block;
  margin-right: 8px;
  vertical-align: middle;
}

.nav-tabs .nav-link {
  cursor: pointer;
  background-color: white;
  color: #333;
  border-color: #dee2e6 #dee2e6 transparent;
}

.nav-tabs .nav-link:hover {
  background-color: #f8f9fa;
  border-color: #dee2e6 #dee2e6 transparent;
}

.nav-tabs .nav-link.active {
  background-color: #0075d2;
  color: white;
  border-color: #0075d2 #0075d2 transparent;
}

/* Estilos para drag and drop */
.dropzone {
  border: 2px dashed #dee2e6;
  border-radius: 8px;
  padding: 40px 20px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  background-color: #f8f9fa;
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.dropzone:hover {
  border-color: #0075d2;
  background-color: #e7f3ff;
}

.dropzone-active {
  border-color: #0075d2;
  background-color: #e7f3ff;
  border-style: solid;
}

.dropzone-has-image {
  padding: 10px;
  min-height: auto;
}

.dropzone-content {
  width: 100%;
}

.dropzone-icon {
  font-size: 48px;
  color: #6c757d;
  margin-bottom: 15px;
  display: block;
}

.dropzone:hover .dropzone-icon,
.dropzone-active .dropzone-icon {
  color: #0075d2;
}

.dropzone-text {
  font-size: 16px;
  color: #495057;
  margin-bottom: 10px;
  font-weight: 500;
}

.dropzone-hint {
  color: #6c757d;
  font-size: 12px;
}

.dropzone-preview {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.dropzone-image {
  max-width: 100%;
  max-height: 300px;
  object-fit: contain;
  border-radius: 8px;
  border: 1px solid #dee2e6;
}

.dropzone-remove {
  margin-top: 10px;
  position: absolute;
  top: -10px;
  right: -10px;
  z-index: 10;
  border-radius: 50%;
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.dropzone-current-label {
  margin-top: 8px;
  font-size: 12px;
  color: #6c757d;
  font-style: italic;
}
</style>
